import { motion } from "framer-motion";

// Calm, editorial reveal-on-scroll wrapper
export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export const eased = [0.16, 1, 0.3, 1];
